import { render, staticRenderFns } from "./ChessGames.vue?vue&type=template&id=2ef388ba&scoped=true&lang=pug"
import script from "./ChessGames.vue?vue&type=script&lang=js"
export * from "./ChessGames.vue?vue&type=script&lang=js"
import style0 from "./ChessGames.vue?vue&type=style&index=0&id=2ef388ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef388ba",
  null
  
)

export default component.exports